export default "__VITE_ASSET__ec24ce7f__"